
export default {
  props: {
    pages: {
      type: Number,
      required: true,
    },
  },

  computed: {
    path() {
      return this.$route.path
    },

    currentPage() {
      return parseInt(this.$route.query?.seite || 1)
    },

    firstPage() {
      return this.currentPage === 1
    },

    lastPage() {
      return this.currentPage === this.pages
    },

    sites() {
      return this.pages <= 5
        ? this.pages
        : [
            this.currentPage - 1,
            this.currentPage,
            this.currentPage + 1,
            this.currentPage + 2,
            this.currentPage + 3,
          ].filter((x) => x > 0 && x <= this.pages)
    },
  },

  methods: {
    scrollToTop() {
      document.querySelector('#start-of-products').scrollIntoView()
    },
  },
}
